import { Fragment, useCallback } from 'react';
import { Hidden, makeStyles } from '@material-ui/core';
import { isVendorPromoEmptySelector } from 'state/promo/selectors';
import { PromoActionType } from 'state/promo/actions';
import { Route } from 'react-router-dom';
import { RoutePath } from 'RoutePath';
import { Text, TextTypography } from 'components/Text/Text';
import { useActionDispatchOnMount, useActivate } from 'core/store/store';
import { useHistory } from 'react-router';
import { useSelector } from 'react-redux';
import i18n from '../../../../i18n';
import { VendorPromoAddDialog } from './components/VendorPromoAddDialog';
import { VendorPromoEditDialog } from './components/VendorPromoEditDialog';
import { VendorPromoList } from './components/VendorPromoList';
import { VendorPromoListEmpty } from './components/VendorPromoListEmpty';
import { makeCatalogFetchProductsRequestAction } from 'state/catalog/actions';

const useStyles = makeStyles(theme => ({
    header: {
        padding: theme.spacing(2),
    },
}));

export const VendorPromo = () => {
    useActivate(PromoActionType.ACTIVATE, PromoActionType.DEACTIVATE);
    const history = useHistory();
    const classes = useStyles();
    const { t } = i18n.useTranslation();
    const isPromoEmpty = useSelector(isVendorPromoEmptySelector);
    useActionDispatchOnMount(true, () => makeCatalogFetchProductsRequestAction());
    const navigateBack = useCallback(() => history.push(RoutePath.VENDOR_PROMO), [history]);

    return (
        <Fragment>
            <Hidden smUp>
                <header className={classes.header}>
                    <Text typography={TextTypography.DISPLAY_STRONG}>{t('vendor:promos.promo')}</Text>
                </header>
            </Hidden>
            {isPromoEmpty ? <VendorPromoListEmpty /> : <VendorPromoList />}
            <Route path={RoutePath.VENDOR_PROMO_EDIT}>
                <VendorPromoEditDialog onClose={navigateBack} />
            </Route>
            <Route path={RoutePath.VENDOR_PROMO_ADD}>
                <VendorPromoAddDialog onClose={navigateBack} />
            </Route>
        </Fragment>
    );
};
